import {
  updateContractSubtype,
  clearContractSubtypeAction,
  clearContractSubtypeErrors,
} from 'actions/contracts/contractSubtypeActions'
import {
  fetchContractTypes,
  clearContractTypeOptions,
} from 'actions/contracts/contractTypeActions'
import AdminForm from 'components/admin/AdminForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const ContractSubtypeUpdate = ({
  formId,
  params,
  setParams,
  closeModal,
  selected,
  setSelected,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { typeOptions } = useSelector((state) => state.contractTypes)
  const { lastAction, subtypeErrors } = useSelector(
    (state) => state.contractSubtypes
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    dispatch(fetchContractTypes('form', selected.contract_type, true))
    return () => {
      dispatch(clearContractTypeOptions())
      dispatch(clearContractSubtypeAction())
      dispatch(clearContractSubtypeErrors())
    }
  }, [dispatch, selected.contract_type])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        id: selected.id,
        name: selected.name,
        contract_type_id: selected.contract_type.id,
      })
    }
  }, [params, setParams, selected])

  useEffect(() => {
    if (lastAction === 'edit') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) || !typeOptions.length ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(updateContractSubtype(params, selected))
      }}
      className="form container"
      noValidate
    >
      <AdminForm
        params={params}
        setParams={setParams}
        selected={selected}
        setSelected={setSelected}
        contractTypes={typeOptions}
        errors={subtypeErrors}
      />
    </form>
  )
}

export default ContractSubtypeUpdate
